import "./project-section.scss";
import { ProjectType } from "types";
import { useRef, useState, useEffect } from "react";
import Project from "./project";

function ProjectSection({ 
  heading, 
  projects, 
  openOptionsModal 
}: {
  heading: string;
  projects: ProjectType[];
  openOptionsModal: (id: number, projectName: string) => void
}) {
  const [expanded, setExpanded] = useState(true);
  const elRef = useRef<any>(null);
  const [height, setHeight] = useState<string>("0px");

  useEffect(() => {
    if (expanded) {
      setHeight("auto");
    } else {
      setHeight("0px");
    }
  }, [expanded, projects]);

  if (!projects.length) {
    return <></>;
  } else {
    return (
      <div className="project-section">
        <div className="project-section-header" onClick={() => setExpanded(!expanded)}>
          <p className={heading.toLowerCase().split(" ").join("-")}>{heading}</p>
          <i className={`fal fa-angle-${expanded ? "up" : "down"}`}></i>
        </div>
        <div className="project-section-projects" ref={elRef} style={{height: height}}>
          {projects != null? projects.sort((a, b) => a.Description.localeCompare(b.Description)).map((project: ProjectType, i: number) => {
            return (
              <Project
                openOptionModal={openOptionsModal}
                project={project}
                key={i}
              />
            );
          }) : <></> }
        </div>
      </div>
    );
  }
}

export default ProjectSection;
